
// 加工厂
import Layout from '@/views/layout/layout'
export const zcckRouters =
  [
    {
      path: '/ZCCK',
      iconCls: 'fa el-icon-s-management', // 图标样式class
      name: '暂存仓库',
      component: Layout,
      meta: { role: ['ZCCK'] },
      children: [
        {
          iconCls: 'el-icon-arrow-right',
          path: '/ZCCK/receive',
          name: '收发货登记',
          meta: { keepAlive: true, url: "/ZCCK/receive.html" },
          component: () => import('@/views/iframe/index.vue')
        }
      ]
    }
  ]


// WEBPACK FOOTER //
// ./src/router/zcck.js